"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_CONTENT = exports.CALL_4_SELLING_CONTENT = exports.PILL_CONTENT = exports.RADIO_CONTENT = exports.BUTTON_CONTENT = exports.CUSTOM_LINK_CONTENT = exports.LIGHT_BOX_CONTENT = void 0;
exports.LIGHT_BOX_CONTENT = {
    CLICK_INSIDE: 'interes',
    CLICK_OUTSIDE: 'cerrar-out',
    CLICK_CLOSE: 'cerrar',
};
exports.CUSTOM_LINK_CONTENT = {
    DEFAULT: 'link',
};
exports.BUTTON_CONTENT = {
    DEFAULT: 'button',
    CONFIRM_PURCHASE: 'confirmar-pedido',
    CTA: 'interes',
};
exports.RADIO_CONTENT = {
    DEFAULT: 'radio',
};
exports.PILL_CONTENT = {
    DEFAULT: 'pill',
};
exports.CALL_4_SELLING_CONTENT = {
    C2C: 'te-llamamos',
    T900: 'llama-gratis'
};
exports.MODAL_CONTENT = {
    DEFAULT: 'modal',
};
//# sourceMappingURL=index.js.map